































































































import Vue from 'vue';
import {
  mapActions,
  mapState,
} from 'vuex';
import AppHeader from '@/components/AppHeader.vue';
import {
  HubButton,
  HubDatePicker,
  HubIcon,
  HubSelect,
} from '@/components/HubComponents';
import {
  RealTimeStatistics,
  RegionStatistics,
  SimultaneousChart,
} from '@/components/Statistics';
import { ViewStatistics } from '../typings/views';

export default Vue.extend({
  name: 'ViewStatistics',

  components: {
    AppHeader,
    HubButton,
    HubDatePicker,
    HubIcon,
    HubSelect,
    RealTimeStatistics,
    RegionStatistics,
    SimultaneousChart,
  },

  props: {
    hash: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      exportFormat: 'png' as ViewStatistics.ExportFormat,
      exportFormatItems: [
        { text: this.$t('pdf_format'), value: 'pdf' },
        { text: this.$t('png_image'), value: 'png' },
      ] as ViewStatistics.ExportFormatItems[],
      finalDate: '',
      initialDate: '',
      isExporting: false,
      maximumDate: new Date(
        new Date().setDate(new Date().getDate() - 1),
      ).toISOString().substr(0, 10),
      menuButtons: [
        {
          icon: 'calendar-month-outline',
          label: this.$t('event'),
          href: `/event/${this.hash}`,
        },
        {
          icon: 'play',
          label: 'Player',
          href: `/player/${this.hash}`,
        },
        {
          icon: 'broadcast',
          label: 'Live Social',
          href: `/live-social/${this.hash}`,
        },
        {
          icon: 'chart-bar',
          label: this.$t('statistics'),
          href: `/statistics/${this.hash}`,
        },
      ],
      minimumDate: new Date(
        (() => {
          const date = new Date();
          date.setHours(0, 0, 0, 0);
          date.setMonth(date.getMonth() - 11);
          date.setDate(1);

          return date;
        })(),
      ).toISOString().substr(0, 10),
      selectedStatisticType: 'real_time',
      statisticsTypes: [
        'real_time',
        'simultaneous',
        'region',
      ],
    };
  },

  computed: {
    ...mapState(['events', 'user']),
    eventState(): Store.Events.Event {
      return this.events.event;
    },
    userState(): Store.User.State {
      return this.user;
    },
  },

  watch: {
    selectedStatisticType(): void {
      const baseItems = [
        { text: `${this.$t('pdf_format')}`, value: 'pdf' },
        { text: `${this.$t('png_image')}`, value: 'png' },
      ] as ViewStatistics.ExportFormatItems[];

      if (this.selectedStatisticType === 'simultaneous') {
        this.exportFormatItems = [
          { text: 'CSV', value: 'csv' },
          ...baseItems,
        ];
      } else {
        this.exportFormatItems = baseItems;
      }
    },
  },

  beforeMount() {
    this.finalDate = this.maximumDate;
    this.initialDate = this.minimumDate;
  },

  async mounted() {
    await this.loadEvent({
      planId: parseInt(this.userState.planId, 10),
      hash: this.hash,
    } as Services.Events.GetEvent);
  },

  methods: {
    ...mapActions({
      loadEvent: 'events/loadEvent',
    }),
    onClickOnDataDownload(): void {
      this.isExporting = true;
      this.$emit(`onClickOnDataDownload__${this.selectedStatisticType}`, this.exportFormat);
    },
  },
});
